const API_VER = 'v1.0'
export const DMSEndpoints = {
    DMS_DEVICE_URI: `/dms/api/${API_VER}/devices/`,
    DMS_ADMIN_DEVICE_URI: `/dms/api/${API_VER}/devices/white_info/`,
    DMS_DEVICE_PERSON_URI: `/dms/api/${API_VER}/devices/persons/`,
    DMS_ADMIN_DEVICE_QTY_URI: `/dms/api/${API_VER}/devices/device_qty/`,
    DMS_COMPANY_DEVICE_URI: `/dms/api/${API_VER}/devices/company_device/`,
    DMS_ADMIN_DEVICE_QTY_RECORD_URI: `/dms/api/${API_VER}/devices/device_qty_record/`,
}
